<template>
  <div id="dashboard-analytics">
    <vx-card slot="no-body h-full" class="d-theme-dark-light-bg mb-base">
      <h1
        class="p-2 font-bold w-full text-primary"
        style="border-bottom: 2px solid;"
      >
        Customer Loan List
      </h1>
      <div class="vx-row">
        <vs-select class="w-full vx-col lg:w-1/4" style="margin-top: 10px;" v-model="selectedCompName">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in tablist"
          />
        </vs-select>
        <vs-button
          v-if="selectAll === false"
          ref="loadableButton"
          id="button-with-loading"
          class="vs-con-loading__container vx-col w-full lg:w-1/4"
          @click="downloadcustomeReport(selected)"
          type="relief"
          style="margin-top: 10px;float: none !important;"
          >Refund Report</vs-button
        >
        <vs-button
          v-else
          ref="loadableButton"
          id="button-with-loading"
          class="vs-con-loading__container vx-col w-full lg:w-1/4"
          @click="downloadAllReport(selected)"
          type="relief"
          style="margin-top: 10px;float: none !important;"
          >Refund Report</vs-button
        >
      </div>
      <template>
        <vs-table
          multiple
          v-model="selected"
          pagination
          max-items="10"
          search
          :data="loanInfo"
        >
          <template slot="thead">
            <vs-th sort-key="email">LOGIN_ID</vs-th>
            <vs-th sort-key="username">CUST/REF(ID) </vs-th>
            <vs-th sort-key="website">NAME</vs-th>
            <vs-th sort-key="id">O/S(P) </vs-th>
            <vs-th sort-key="email">STATUS</vs-th>
            <vs-th sort-key="username">REQ/DIS_DATE</vs-th>
            <vs-th sort-key="website">STAGE</vs-th>
            <vs-th sort-key="id">EXP_MATURE_DATE</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="indextr" v-for="(row, indextr) in data">
              <vs-td >
                {{row.loginID}}
              </vs-td>

              <vs-td>
                {{row.customerID}}({{row.loanReferenceID}})
              </vs-td>

              <vs-td>
                {{row.name}}
              </vs-td>

              <vs-td>
                {{row.totalOutstanding}}({{row.principal}})
              </vs-td>
              <vs-td>
                {{ row.status}}
              </vs-td>

              <vs-td>
                {{row.loanRequestDate}}
              </vs-td>

              <vs-td >
                {{row.stage}}
              </vs-td>

              <vs-td >
                {{ row.expectedMaturityDate}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tabSelected: 1,
      tablist: [
        { text: "CHAITANYA", value: "CHAITANYA" },
        { text: "GETCLARITY", value: "GETCLARITY" },

      ],
      successMessage : '',
      loanInfo:[],
                showButton : true,
                file : null,
                selectAll: false,
                selectedID: [],
                disabled : 1,
                file : null,
                forceUpdatFlag:0,
                custID :'',
                successMessage : '',
                showButton : true,

                options: [100, 250, 500, 1000],
                entries: 100,
                selectedDropDown : 'login_id',
                selectedFormat : 'RBL',
                selectedCompName:'CHAITANYA',
                pages: [],
              loanreferenceID:[],
              activePage: 0,
              search: '',
      selected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      users: [
        {
          id: 1,
          name: "Leanne Graham",
          username: "Bret",
          email: "Sincere@april.biz",
          website: "hildegard.org",
        },
        {
          id: 2,
          name: "Ervin Howell",
          username: "Antonette",
          email: "Shanna@melissa.tv",
          website: "anastasia.net",
        },
        {
          id: 3,
          name: "Clementine Bauch",
          username: "Samantha",
          email: "Nathan@yesenia.net",
          website: "ramiro.info",
        },
        {
          id: 4,
          name: "Patricia Lebsack",
          username: "Karianne",
          email: "Julianne.OConner@kory.org",
          website: "kale.biz",
        },
        {
          id: 5,
          name: "Chelsey Dietrich",
          username: "Kamren",
          email: "Lucio_Hettinger@annie.ca",
          website: "demarco.info",
        },
        {
          id: 6,
          name: "Mrs. Dennis Schulist",
          username: "Leopoldo_Corkery",
          email: "Karley_Dach@jasper.info",
          website: "ola.org",
        },
        {
          id: 7,
          name: "Kurtis Weissnat",
          username: "Elwyn.Skiles",
          email: "Telly.Hoeger@billy.biz",
          website: "elvis.io",
        },
        {
          id: 8,
          name: "Nicholas Runolfsdottir V",
          username: "Maxime_Nienow",
          email: "Sherwood@rosamond.me",
          website: "jacynthe.com",
        },
        {
          id: 9,
          name: "Glenna Reichert",
          username: "Delphine",
          email: "Chaim_McDermott@dana.io",
          website: "conrad.com",
        },
        {
          id: 10,
          name: "Clementina DuBuque",
          username: "Moriah.Stanton",
          email: "Rey.Padberg@karina.biz",
          website: "ambrose.net",
        },
      ],
    };
  },
  components: {},
  created() {
    this.$store.commit("routeChange", "start");

            var timestamp = Math.round(+new Date() / 1000);
            var userip = this.$store.getters.ipAddress;
            var data = {
                  loanStatus:[],
                  page: {
                  startIndex: 0,
                  size: 10000
                  },
                  days: 0,
                  fromDate: "",
                  toDate: "",
                  mandate: 0,
                  dueThisWeek : '',
                  dueAll : '',
                  stage :"REFUND_INITIATED",
            };
            var msgHeader = {
                authToken: localStorage.getItem('authtoken'), //dynamic
                authLoginID: this.$store.getters.loginId,
                timestamp: timestamp,
                ipAddress: userip
            };
            this.$root.$emit('component1',false);
            var mlShowMandateData = {data, msgHeader};
            const instance = axios.create();

            // Override timeout default for the library
            // Now all requests using this instance will wait 2.5 seconds before timing out
            instance.defaults.timeout = 6000000;
            instance.post('mlListLoans', mlShowMandateData).then((response) => {

                const JSONData = response.data;
                if (JSONData.data.error == 0) {

                    this.loanInfo = JSONData.data.loanInfo;
                    //this.rows = JSONData.data.mandateData;
                    for (var i=0;i<this.loanInfo.length;i++)
                  {
                    this.loanreferenceID.push(this.loanInfo[i].loanReferenceID)
                    console.log("this is the reference id array",this.loanreferenceID)

                  }


                }
                else {
                    this.error = JSONData.data.message;
                    this.$store.commit('setloginId', {
                        loginid: ''
                    });
                    this.$store.commit('setauthtoken', {
                        authtoken: ''
                    });

                    this.$root.$emit('logout');
                }

                  this.$store.commit("routeChange", "end");

            })
  },
  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    downloadcustomeReport : function(selected)
          {
              this.$store.commit("routeChange", "start");
            var loanRefIDs = [];
            for(var j = 0;j<selected.length;j++)
            {

                      loanRefIDs.push(this.selected[j].loanReferenceID);


            }
            var timestamp = Math.round(+new Date() / 1000);
            var userip = this.$store.getters.ipAddress;
            var data = {
                loanRefIDs : loanRefIDs,
                lender : this.selectedCompName
            };
            var msgHeader = {
              authToken: localStorage.getItem('authtoken'), //dynamic
              authLoginID: this.$store.getters.loginId,
              timestamp: timestamp,
              ipAddress: userip
            };
            //post request

            var loginv2 = {data, msgHeader};
            axios.post('mlGenerateRefundReport', loginv2).then((response) => {
                const JSONData = response.data;
                //if success
                console.log("display log =="+JSON.stringify(JSONData));
                if (JSONData.data.error == 0) {
                    //set auth token


                    axios({
                        url: 'mlS3Read?customerID=0&docSeqID='+JSONData.data.fileID,
                        method: 'GET',
                        responseType: 'blob', // important
                      }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.csv');
                        document.body.appendChild(link);
                        link.click();
                      });
                }
                //error message
                else {

                    this.email = '';
                    this.password = '';
                    this.error = JSONData.data.message;


                    this.$store.commit('setloginId', {
                        loginid: ''
                    });
                    this.$store.commit('setauthtoken', {
                        authtoken: ''
                    });
                    this.$root.$emit('logout');
                }
                  this.$store.commit("routeChange", "end");
            })
          },
          downloadAllReport : function(selected)
          {
            this.$store.commit("routeChange", "start");
            // var loanRefIDs = [];
            // loanRefIDs.push(this.custId);
            var timestamp = Math.round(+new Date() / 1000);
            var userip = this.$store.getters.ipAddress;

            var data = {
              loanRefIDs : this.loanreferenceID,
              lender : this.selectedCompName
            };
            var msgHeader = {
              authToken: localStorage.getItem('authtoken'), //dynamic
              authLoginID: this.$store.getters.loginId,
              timestamp: timestamp,
              ipAddress: userip
            };
            //post request

            var loginv2 = {data, msgHeader};
            axios.post('mlGenerateRefundReport', loginv2).then((response) => {
                const JSONData = response.data;
                //if success
                console.log("display log =="+JSON.stringify(JSONData));
                if (JSONData.data.error == 0) {
                    //set auth token
                    

                    axios({
                        url: 'mlS3Read?customerID=0&docSeqID='+JSONData.data.fileID,
                        method: 'GET',
                        responseType: 'blob', // important
                      }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.csv');
                        document.body.appendChild(link);
                        link.click();
                      });
                }
                //error message
                else {

                    this.email = '';
                    this.password = '';
                    this.error = JSONData.data.message;


                    this.$store.commit('setloginId', {
                        loginid: ''
                    });
                    this.$store.commit('setauthtoken', {
                        authtoken: ''
                    });
                    this.$root.$emit('logout');
                }
                this.$store.commit("routeChange", "end");

            })
          },
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
